import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import config from '../../../../config'
import Header from '../../../Header';
import '../../../Dashboard/css/liquiditypool.css';
import '../../../Dashboard/css/simplestaking.css'
import { Container, Row, Col, Form, Button, Modal, Accordion, Card } from 'react-bootstrap';
import RangeSlider from 'react-bootstrap-range-slider';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import Web3ModalProvider from '../../../Pages/Presale/Connectwallet/Web3ModalProvider';
import { useSelector } from 'react-redux';
import { BloackchainCheckAllowanceAndApprove, BloackchainGetTokenBalance } from '../../../Web3/SwapConnector';
import { FEE_SYMBOL, INFI_DECIMAL, STAKING_CONTRACT, STAKING_DURATION, TOKEN_A, TOKEN_B, USDT_DECIMAL } from '../../../Web3/web3Config';
import { BloackchainGetEstimatedAmountAfterUnstake, BloackchainGetStakingDetails, BloackchainGetStakingFees, BloackchainGetStakingMinMaxAmount, BloackchainGetStakingTokensBalance, BloackchainReStakeNow, BloackchainRewardClaimNow, BloackchainStakeToken, BloackchainUnStakeAndSellToken, BloackchainUnStakeNow, BloackchainGetTotalContractStaking } from '../../../Web3/StakingConnector';
import { Spin } from 'antd';
import { ClipLoader } from 'react-spinners';
import { Success, Warning } from '../../../../utils/errors';
import Tooltip from 'react-tooltip-lite';
import Appsidebar from '../../../Appsidebar';





const Simplestaking = () => {
  const [stakingPercent, setStakingPercent] = React.useState(25);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const _useWeb3ModalProvider = Web3ModalProvider()
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const [connectWalletNow, setConnectWalletNow] = useState(false);
  const [WalletAddress, setWalletAddress] = useState("")
  const [stakeAmount, setStakeAmount] = useState(0)
  const [statkingFee, setStatkingFee] = useState(0)
  const [stakeLoading, setStakeLoading] = useState(false);
  const [stakingList, setStakingList] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalStake, setTotalStake] = useState(0)

  const [isProviderLoaded, setisProviderLoaded] = useState(false);
  useEffect(() => {
    setWalletAddress(walletConnnected);
  }, [walletConnnected])

  useEffect(() => {
    if (!isProviderLoaded) {
      _useWeb3ModalProvider.then(data => {
        if (data) {
          setisProviderLoaded(true);
        }
      })
    }
  }, [_useWeb3ModalProvider])

  useEffect(() => {
    if (isProviderLoaded) {
      setInterval(() => {
        getWalletBalance();
      }, 5000)
      getWalletBalance();
    }
  }, [isProviderLoaded]);

  const [tokenA, setTokenA] = useState(TOKEN_A)
  const [tokenB, setTokenB] = useState(TOKEN_B)

  const getWalletBalance = async () => {
    try {
      let tokenARes = await BloackchainGetTokenBalance(walletConnnected, TOKEN_A.contract, _useWeb3ModalProvider);
      let tokenBRes = await BloackchainGetTokenBalance(walletConnnected, TOKEN_B.contract, _useWeb3ModalProvider);
      console.log('zxc', tokenARes, tokenBRes)
      if (tokenARes.status) {
        setTokenA({ ...tokenA, balance: tokenARes.balance }) //tokenARes.balance 
      }
      else {
        Warning(tokenARes.message);
      }
      if (tokenBRes.status) {
        setTokenB({ ...tokenB, balance: tokenBRes.balance })
      }

      const stakingRes = await BloackchainGetStakingDetails(walletConnnected, STAKING_CONTRACT, _useWeb3ModalProvider);
      if (stakingRes.status) {
        setIsLoading(false);
        if (stakingRes.data.length > 0) {
          setStakingList(stakingRes.data)
        } else {
          setStakingList([])
        }
      }
      else {
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsLoading(false);
      console.log('error in getWalletBalance', error);
    }
  }

  const goToLogin = async () => {
    navigate(config.baseurl + 'login')
  }

  const handleClose = () => {
    setShow(false);
    setStakingPercent(25)
  }
  const handleShow = () => {
    setShow(true);
    calculatePositionOverview()
  }

  const [stakeErr, setStakeErr] = useState("");

  const calculatePositionOverview = async () => {
    let stakeAmt = parseFloat(tokenA.balance * stakingPercent / 100).toFixed(6);
    setStakeAmount(stakeAmt);
    const getMinMaxStake = await BloackchainGetStakingMinMaxAmount(stakeAmt, INFI_DECIMAL, STAKING_CONTRACT, _useWeb3ModalProvider);
    if (getMinMaxStake.status) {
      setStakeErr(getMinMaxStake.message);
      // const stakingFeeRes = await BloackchainGetStakingFees(walletConnnected, stakeAmt, INFI_DECIMAL, USDT_DECIMAL, STAKING_CONTRACT, _useWeb3ModalProvider);
      // if (stakingFeeRes.status) {
      //   setStatkingFee(stakingFeeRes.fee);
      //   if (parseFloat(stakingFeeRes.fee) > parseFloat(tokenB.balance)) {
      //     setStakeErr('Insufficiant USDT balance for fees')
      //   }
      // }
    }
    else {
      setStakeErr(getMinMaxStake.message + ' ' + tokenA.symbol);
    }
  }

  useEffect(() => {
    calculatePositionOverview()
  }, [stakingPercent])

  const [stakeProcessingText, setStakeProcessingText] = useState('Please wait');
  const [stakingDetails, setStakingDetails] = useState({});
  const [unstakingAmount, setUnstakingAmount] = useState({});
  const [amountErr, setAmountErr] = useState('');
  const [estimatedInfo, setEstimatedInfo] = useState('');

  const stakeNow = async () => {
    setStakeLoading(true);
    setStakeProcessingText(' INFI Approval in progress');

    let request = {
      walletProvider: _useWeb3ModalProvider,
      walletAddress: WalletAddress,
      contractAddress: tokenA.contract,
      amount: parseFloat(stakeAmount).toFixed(6),
      liquidityContract: STAKING_CONTRACT,
      infiDecimal: INFI_DECIMAL
    }

    if (
      WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()
    ) {
      Warning("Please connect with registered wallet");
      return;
    }

    let res1 = await BloackchainCheckAllowanceAndApprove(request);
    //console.log('xxxxx',res1)
    if (res1.status) {
      request.amount = stakeAmount;
      request.stakingContractAddress = STAKING_CONTRACT;
      setStakeProcessingText(' Token staking in progress');
      let res = await BloackchainStakeToken(request)
      // console.log('zxc',res)
      setStakeLoading(false);
      if (res.status) {
        handleClose();
        getWalletBalance()
        Success("Token staked completed successfully. It will take a few minutes to confirm the transaction.");
      } else {
        // setStakeProcessing(0);
        setStakeLoading(false);
        Warning(res.message)
      }
    }
    else {
      // setFeeApprovalProcessing(0);
      setStakeLoading(false);
      Warning(res1.message);
    }
  }

  //  unstake & sell process
  const [show1, setShow1] = useState(false);
  const handleShow1 = (item) => {

    if (item.usdtReward > 0) {
      Warning("Please claim your previous reward before unstake.")
      return;
    }

    setStakingDetails(item);
    setUnstakingAmount(item.amount);
    calculateExpactedAmount(item.amount, item.amount)
    setShow1(true);
  }

  const handleClose1 = () => {
    setShow1(false);
    setAmountErr('');
  }

  const calculateExpactedAmount = async (value, stakedAmount) => {
    setUnstakingAmount(value);
    if (value > stakedAmount) {
      setAmountErr('Amount should be less then or equals to staked amount.')
      return;
    }
    setAmountErr('');
    let request = {
      walletProvider: _useWeb3ModalProvider,
      amount: value,
      stakingContractAddress: STAKING_CONTRACT,
      infiDecimal: INFI_DECIMAL,
      usdtDecimal: USDT_DECIMAL
    }
    const estimatedResult = await BloackchainGetEstimatedAmountAfterUnstake(request);
    console.log({ estimatedResult });
    if (estimatedResult.status) {
      setEstimatedInfo(estimatedResult)
    }
  }

  useEffect(() => {
    const fetchTotalStaking = async () => {
      try {
        let res = await BloackchainGetTotalContractStaking(STAKING_CONTRACT, _useWeb3ModalProvider);
        //console.log('Total Staking:', res.total);
        setTotalStake(res.total)
      } catch (error) {
        console.error('Error getting total staking:', error);
      }
    };

    fetchTotalStaking();
  }, [STAKING_CONTRACT, _useWeb3ModalProvider]); // Add dependencies if they can change


  const unStakeAndSellNow = async () => {

    const getBalance = await BloackchainGetStakingTokensBalance(STAKING_CONTRACT, _useWeb3ModalProvider)

    if (!getBalance.status) {
      Warning(getBalance.message)
      return;
    }
    if (getBalance.status) {

      if (getBalance.infi < (parseFloat(estimatedInfo.finalAmount) + parseFloat(estimatedInfo.penalty))) {
        Warning("Insufficient INFI balance in staking pool")
        return;
      }
    }

    setStakeLoading(true);
    let request = {
      walletProvider: _useWeb3ModalProvider,
      walletAddress: WalletAddress,
      amount: unstakingAmount,
      stakingIndex: parseInt(stakingDetails.index),
      stakingContractAddress: STAKING_CONTRACT,
      infiDecimal: INFI_DECIMAL
    }
    if (
      WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()
    ) {
      Warning("Please connect with registered wallet");
      return;
    }

    let res = await BloackchainUnStakeAndSellToken(request);
    setStakeLoading(false);
    if (res.status) {
      handleClose1();
      getWalletBalance();
      Success("Token unstaked successfully! Amount will be transferred to your wallet address.");
    } else {
      Warning(res.message)
    }
  }

  // Claim Process
  const [claimProcessing, setClaimProcessing] = useState(false);
  const rewardClaimNow = async (item) => {
    const getBalance = await BloackchainGetStakingTokensBalance(STAKING_CONTRACT, _useWeb3ModalProvider)

    if (!getBalance.status) {
      Warning(getBalance.message)
      return;
    }
    if (getBalance.status) {
      // if (getBalance.wbtc < item.wbtcReward) {
      //   Warning("Insufficient WBTC balance in staking pool")
      //   return;
      // }
      if (getBalance.usdt < item.usdtReward) {
        Warning("Insufficient USDT balance in staking pool")
        return;
      }
    }

    setClaimProcessing(true);

    let request = {
      walletProvider: _useWeb3ModalProvider,
      walletAddress: WalletAddress,
      stakingIndex: parseInt(item.index),
      stakingContractAddress: STAKING_CONTRACT
    }
    if (
      WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()
    ) {
      Warning("Please connect with registered wallet");
      return;
    }

    let res = await BloackchainRewardClaimNow(request);
    setClaimProcessing(false);
    if (res.status) {
      getWalletBalance();
      Success("Reward claimed successfully.It will take a few minutes to confirm the transaction.");
    } else {
      Warning(res.message);
    }
  }

  // unstake process
  const [unstakeProcessing, setUnstakeProcessing] = useState(false);
  const unStakeNow = async (item) => {
    if (item.usdtReward > 0) {
      Warning("Please claim your previous reward before unstake.")
      return;
    }
    setUnstakeProcessing(true);
    let request = {
      walletProvider: _useWeb3ModalProvider,
      walletAddress: WalletAddress,
      stakingIndex: parseInt(item.index),
      stakingContractAddress: STAKING_CONTRACT,
      amount: item.amount,
      infiDecimal: INFI_DECIMAL
    }
    if (
      WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()
    ) {
      Warning("Please connect with registered wallet");
      return;
    }

    let res = await BloackchainUnStakeNow(request);
    setUnstakeProcessing(false);
    if (res.status) {
      getWalletBalance();
      Success("Token unstaked successfully. Amount will be transferred to your wallet address.");
    } else {
      Warning(res.message);
    }
  }

  const [restakeProcessing, setRestakeProcessing] = useState(false);
  const reStakeNow = async (item) => {
    if (item.usdtReward > 0) {
      Warning("Please claim your previous reward before unstake.")
      return;
    }

    setRestakeProcessing(true);
    let request = {
      walletProvider: _useWeb3ModalProvider,
      walletAddress: WalletAddress,
      stakingIndex: parseInt(item.index),
      stakingContractAddress: STAKING_CONTRACT
    }
    if (
      WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()
    ) {
      Warning("Please connect with registered wallet");
      return;
    }

    let res = await BloackchainReStakeNow(request);
    setRestakeProcessing(false);
    if (res.status) {
      getWalletBalance();
      Success("Token restaked successfully.");
    }
    else {
      Warning(res.message);
    }
  }

  return (
    <>
    <div className='dashboard'>
      <Header connectWalletNow={connectWalletNow} setconnectWalletNow={setConnectWalletNow} />

      {/* ------ Unstake & sell Start------- */}
      <Modal show={show1} onHide={handleClose1} centered backdrop={'static'} keyboard={false} className='modalBox'>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <div className=''>
                <div className='d-flex justify-content-between align-items-end my-4'>
                  <h4 class="mb-0 text-dark">UNSTAKE INFI TOKEN</h4>
                  <div>
                    <h4 className='text-blue fw-bold mb-0'>
                      <img src={tokenA.icon} style={{ lineHeight: "0" }} width="35px" />&nbsp; {tokenA.symbol}
                    </h4>
                  </div>
                </div>

                <Form>
                  <Form.Group as={Row} className='align-items-end range-slider'>
                    <Col xs="12">
                      <p className='mb-0 text-dark'>Staked Amount: {parseFloat(stakingDetails.amount).toFixed(6)} {tokenA.symbol}</p>
                    </Col>
                    <Col xs="12">
                      <br />
                      <Form.Label className='text-dark'>Enter Amount</Form.Label>
                      <Form.Control type="text" placeholder="0" name='fromAmount' onKeyPress={(event) => { if (!/^\d*[.]?\d{0,1}$/.test(event.key)) { event.preventDefault(); } }} value={unstakingAmount} onInput={(e) => calculateExpactedAmount(e.target.value, stakingDetails.amount)} autoComplete='off' />
                      {amountErr != "" &&
                        <p style={{ color: 'red' }}>
                          {amountErr}
                        </p>
                      }
                    </Col>

                  </Form.Group>
                </Form>
                <Row className='justify-content-center '>

                  <Col lg={12} className='my-3'>
                    <h5 className='mb- text-dark'>OVERVIEW</h5>
                  </Col>
                  <Col lg={5} xs={5} className='mb-2'>
                    <p className='mb-0 small text-dark'>Receive Estimated Amount</p>
                  </Col>
                  <Col lg={7} xs={7} className='text-right mb-2'>
                    <h5 className='mb-0 small text-blue'>{estimatedInfo.finalAmount} INFI</h5>
                  </Col>
                  <Col lg={5} xs={5} className='mb-2'>
                    <p className='mb-0 small text-dark'>Penalty</p>
                  </Col>
                  <Col lg={7} xs={7} className='text-right mb-2'>
                    <h5 className='mb-0 small text-blue'>{estimatedInfo.penalty} INFI</h5>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg={12} md={12} xs={12} sm={12}>
                    {amountErr !== "" ?
                      <Button className='w-100 fw-bold stakeDisabledBtn' disabled>UNSTAKE WITH PENALTY</Button>
                      :
                      <>
                        {!stakeLoading ?
                          <Button className='w-100 fw-bold text-black' onClick={unStakeAndSellNow}>UNSTAKE WITH PENALTY</Button>
                          :
                          <Button className='w-100 fw-bold stakeDisabledBtn' disabled><ClipLoader size={20} /> Please wait</Button>
                        }
                      </>
                    }
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

        </Modal.Body>

      </Modal>
      {/* -------Unstake & sell End------ */}

      {/* ------STAKE AMOUNT Start------- */}
      <Modal show={show} onHide={handleClose} centered backdrop={'static'} keyboard={false} className='modalBox'>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <div className=''>
                <div className='d-flex justify-content-between align-items-end my-4'>
                  <h5 class="mb-0 text-primary">STAKE INFI TOKEN</h5>
                  <div>
                    <h4 className='text-blue fw-bold mb-0'>
                      <img src={tokenA.icon} style={{ lineHeight: "0" }} width="35px" />&nbsp; {tokenA.symbol}
                    </h4>
                  </div>
                </div>

                <Form>
                  <Form.Group as={Row} className='align-items-end range-slider'>
                    <Col xs="6" className=''>
                      {/* ~ */}
                      <p className='mb-0 text-primary'>Balance: {parseFloat(tokenA.balance).toFixed(6)} {tokenA.symbol}</p>
                    </Col>
                    <Col xs="6" className=''>
                      <Form.Control value={`${stakingPercent}%`} className='text-right bg-transparent border-0 fs-1 p-0' disabled />
                    </Col>
                    <Col xs="12" className='range-custom-slider'>
                      <RangeSlider
                        className='w-100'
                        value={stakingPercent}
                        onChange={e => setStakingPercent(e.target.value)}
                        variant='success'
                      />
                    </Col>

                  </Form.Group>
                </Form>
                <Row className='justify-content-center mb-4'>
                  <Col lg={3} xs={3} className='mb-2'>
                    <Button className='w-100 text-blue bg-blue percentage' onClick={e => setStakingPercent(25)}>25%</Button>
                  </Col>
                  <Col lg={3} xs={3} className='text-right mb-2'>
                    <Button className='w-100 text-blue bg-blue percentage' onClick={e => setStakingPercent(50)}>50%</Button>
                  </Col>
                  <Col lg={3} xs={3} className='mb-2'>
                    <Button className='w-100 text-blue bg-blue percentage' onClick={e => setStakingPercent(75)}>75%</Button>
                  </Col>
                  <Col lg={3} xs={3} className='text-right mb-2'>
                    <Button className='w-100 text-blue bg-blue percentage' onClick={e => setStakingPercent(100)}>Max</Button>
                  </Col>
                </Row>
                <Row className='justify-content-center '>

                  <Col lg={12} className='my-3'>
                    <h5 className='mb-0 text-primary'>POSITION OVERVIEW</h5>
                  </Col>
                  <Col lg={5} xs={5} className='mb-2'>
                    <p className='mb-0 small text-primary'>Stake Amount</p>
                  </Col>
                  <Col lg={7} xs={7} className='text-right mb-2'>
                    <h5 className='mt-1 mb-0 small text-blue'>{stakeAmount} INFI</h5>
                  </Col>
                  <Col lg={5} xs={5} className='mb-2'>
                    <p className='mb-0 small text-primary'>Duration</p>
                  </Col>
                  <Col lg={7} xs={7} className='text-right mb-2'>
                    <h5 className='mt-1 mb-0 small text-blue'>{STAKING_DURATION}</h5>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg={12} md={12} xs={12} sm={12}>
                    {stakeErr !== "" ?
                      <Button className='w-100 fw-bold stakeDisabledBtn' disabled>{stakeErr}</Button>
                      :
                      <>
                        {!stakeLoading ?
                          <Button className='w-100 fw-bold' onClick={stakeNow}>STAKE NOW</Button>
                          :
                          <Button className='w-100 fw-bold stakeDisabledBtn' disabled><ClipLoader size={20} /> &nbsp;{stakeProcessingText}</Button>
                        }
                      </>
                    }
                  </Col>
                </Row>
                <br />
              </div>
            </Col>
          </Row>

        </Modal.Body>

      </Modal>

      {/* -------STAKE AMOUNT End------ */}



      <div className="wrapper">
        <Appsidebar />
        <div id="content" className='position-relative'>
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="pb-5 simplestaking">
                  <Row className="justify-content-center">
                    <Col lg={12} xs={12} className='mb-4'>
                      <Card className='border-0 border-bottom bg-transparent rounded-0' >
                        <Card.Body className='px-0'>
                          <h3 className=' text-primary mb-0'>Total Staked INFI - <span className='fw-normal'>{totalStake} INFI</span>
                            <span className='ms-1'><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 48" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z" fill="url(#paint0_linear_431_29)" />
                              <defs>
                                <linearGradient id="paint0_linear_431_29" x1="16.0002" y1="0" x2="16.0002" y2="47.3928" gradientUnits="userSpaceOnUse">
                                  <stop stop-color="#55C57D" />
                                  <stop offset="1" stop-color="#4CBAD5" />
                                </linearGradient>
                              </defs>
                            </svg>
                            </span>
                            </h3>

                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>

                      <Row className='align-items-center mb-3'>
                        <Col lg={6} xs={6}>
                          <h1 className='text-primary'>Your Staking</h1>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} className='mb-2 text-right'>
                          {loginDetails.isLogin ?
                            <>
                              {walletConnnected &&
                                <Button variant='custombtn5' className='fs-5 px-5' onClick={handleShow} >STAKE NOW</Button>
                                // :
                                // <Button className='w-50 fw-bold text-black' onClick={() => setConnectWalletNow(true)}>CONNECT WALLET</Button>
                              }
                            </>
                            :
                            <Button className='w-50 fw-bold text-black' onClick={goToLogin}>LOGIN TO STAKE</Button>
                          }
                        </Col>
                      </Row>
                      {stakingList.length > 0 &&
                        <>
                        </>
                      }

                      <Row >
                        <Col lg={12}>
                          <div className='default-acc'>


                            <div className='Accordion-table'>
                              {loginDetails.isLogin ?
                                <>
                                  {walletConnnected ?
                                    <Accordion>

                                      {IsLoading ?
                                        <center>
                                          <Spin spinning={IsLoading}></Spin>
                                        </center>
                                        :
                                        <>
                                          {stakingList.length === 0 &&
                                            <Accordion.Item className='mb-4 cardBox border-0'>
                                              <Accordion.Header className='table-h text-center' >
                                                <h4 className='text-center text-primary'><center>No Staking Found</center></h4>
                                              </Accordion.Header>
                                            </Accordion.Item>
                                          }
                                        </>}
                                      <>
                                        {stakingList.map((item, i) => (
                                          <Accordion.Item eventKey={i} className='mb-4 cardBox border-0'>
                                            {console.log('zzz', item)}
                                            <Accordion.Header className='table-h' >
                                              <Row className='justify-content-sm-between w-100'>
                                                <Col lg={2} md={2} sm={7} xs={7} className='mb-sm-3 mb-xs-1'>
                                                  <div className=''>
                                                    <div className='d-flex align-items-center'>
                                                      <div className='me-2'>
                                                      </div>
                                                      <div>
                                                        <span className='fs-4 text-blue'>INFI</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </Col>
                                                <Col lg={3} md={3} sm={5} xs={5} className='mb-sm-3 mb-xs-1'>
                                                  <div className=''>
                                                    <div className=''>
                                                      <h5 className='mb-0 text-primary'> My Staked INFI</h5>
                                                      <h5 className='mb-0 text-xs-wrap text-primary'>{parseFloat(item.amount).toFixed(6)}</h5>
                                                    </div>
                                                  </div>

                                                </Col>
                                                <Col lg={3} md={3} sm={7} xs={7}>
                                                  {/* {console.log('xxxxx',item.startDate)} */}
                                                  <div className='total-staked'>
                                                    <div className=''>
                                                      <h5 className='mb-0 text-primary'>Start Date </h5>
                                                      <h5 className='mb-0 text-primary'>{item.startDate}</h5>
                                                    </div>
                                                  </div>
                                                </Col>

                                                <Col lg={3} md={3} sm={7} xs={7}>
                                                  <div className='total-staked'>
                                                    <div className=''>
                                                      <h5 className='mb-0 text-primary'>End Date </h5>
                                                      <h5 className='mb-0 text-primary'>{item.endDate}</h5>
                                                    </div>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                              <div>
                                                <h4 className='text-primary'>My Profit Estimate </h4>
                                                <Row className='align-items-end'>
                                                  <Col lg={2} xs={6} className='mb-2'>
                                                    <p className='mb-0 small text-primary'>USDT</p>
                                                  </Col>
                                                  <Col lg={4} xs={6} className='text-right mb-2'>
                                                    <h5 className='mb-0 small text-blue  text-left'>{(item.usdtReward).toFixed(6)} USDT</h5>
                                                  </Col>
                                                </Row>
                                                {/* <Row className='align-items-end'>
                                                  <Col lg={2} xs={6} className='mb-2'>
                                                    <p className='mb-0 small text-primary'>WBTC</p>
                                                  </Col>
                                                  <Col lg={4} xs={6} className='text-right mb-2'>
                                                    <h5 className='mb-0 small text-blue  text-left'>{(item.usdtReward).toFixed(6)} WBTC</h5>
                                                  </Col>
                                                </Row>
                                                <Row className='align-items-end'>
                                                  <Col lg={2} xs={6} className='mb-2'>
                                                    <p className='mb-0 small text-primary'>USDC</p>
                                                  </Col>
                                                  <Col lg={4} xs={6} className='text-right mb-2'>
                                                    <h5 className='mb-0 small text-blue  text-left'>{(item.usdtReward).toFixed(6)} USDC</h5>
                                                  </Col>
                                                </Row>
                                                <Row className='align-items-end'>
                                                  <Col lg={2} xs={6} className='mb-2'>
                                                    <p className='mb-0 small text-primary'>INFI</p>
                                                  </Col>
                                                  <Col lg={4} xs={6} className='text-right mb-2'>
                                                    <h5 className='mb-0 small text-blue  text-left'>{(item.usdtReward).toFixed(6)} INFI</h5>
                                                  </Col>
                                                </Row> */}
                                                <br />
                                                <Row className='align-items-end'>
                                                  {item.todayTimeStamp < item.endTimeStamp &&
                                                    <Col xxl={2} xl={2} lg={3} md={3} className='mb-2'  >
                                                      <Button className='w-100 fw-bold text-nowrap' onClick={(e) => handleShow1(item)}>Unstake With Penalty</Button>
                                                    </Col>
                                                  }

                                                  {/* <Col xxl={2} xl={2} lg={3} md={3} className='mb-2'>
                                                  {item.usdtReward > 0 ?
                                                    <>
                                                      {!claimProcessing ?
                                                        <Button className='w-100 fw-bold' onClick={() => rewardClaimNow(item)} disabled>
                                                          Claim
                                                        </Button>
                                                        :
                                                        <Button className='w-100 fw-bold' disabled>
                                                          <ClipLoader size={15} /> Please wait
                                                        </Button>
                                                      }
                                                    </>
                                                    :
                                                    <Tooltip place="top" content="You can claim your reward every month.">
                                                      <Button className='w-100 fw-bold' disabled>
                                                        Claim
                                                      </Button>
                                                    </Tooltip>
                                                  }
                                                </Col> */}
                                                  <Col xxl={3} xl={3} lg={3} md={3} className='mb-2'>
                                                    {!unstakeProcessing ?
                                                      <>
                                                        {item.todayTimeStamp > item.endTimeStamp ?
                                                          <Button className='w-100 fw-bold' onClick={() => unStakeNow(item)}>
                                                            Unstake
                                                          </Button>
                                                          :
                                                          <Tooltip place="top" content="You can unstake INFI after completed staking period.">
                                                            <Button className='w-100 fw-bold' disabled>
                                                              Unstake
                                                            </Button>
                                                          </Tooltip>
                                                        }
                                                      </>
                                                      :
                                                      <Button className='w-100 fw-bold' disabled>
                                                        <ClipLoader size={20} /> &nbsp; Please wait
                                                      </Button>
                                                    }
                                                  </Col>
                                                  <Col xxl={3} xl={3} lg={3} md={3} className='mb-2'>
                                                    {!restakeProcessing ?
                                                      <>
                                                        {console.log("todayTimeStamp", item.todayTimeStamp, item.restakeEnableTimeStamp, item.todayTimeStamp, item.endTimeStamp, (item.todayTimeStamp >= item.restakeEnableTimeStamp && item.todayTimeStamp <= item.endTimeStamp))}
                                                        {item.todayTimeStamp >= item.restakeEnableTimeStamp && item.todayTimeStamp <= item.endTimeStamp ?
                                                          <Button className='w-100 fw-bold' onClick={() => reStakeNow(item)}>
                                                            Restake
                                                          </Button>
                                                          :
                                                          <Tooltip place="top" content="You can restake INFI in last 7 days of staking end date.">
                                                            <Button className='w-100 fw-bold' disabled>
                                                              Restake
                                                            </Button>
                                                          </Tooltip>
                                                        }
                                                      </>
                                                      :
                                                      <Button className='w-100 fw-bold stakeDisabledBtn' disabled>
                                                        <ClipLoader size={20} /> &nbsp; Please wait
                                                      </Button>
                                                    }
                                                  </Col>

                                                </Row>
                                              </div>
                                            </Accordion.Body>
                                          </Accordion.Item>

                                        ))}

                                      </>
                                    </Accordion>
                                    :

                                    // <div>

                                    // </div>
                                    <center> <br /><Button className='px-5 fw-bold text-light' onClick={() => setConnectWalletNow(true)}>CONNECT WALLET</Button>
                                    </center>
                                  }
                                </>
                                :
                                <Button className='w-50 fw-bold text-black' onClick={goToLogin}>LOGIN TO STAKE</Button>
                              }
                            </div>
                          </div>
                        </Col>

                      </Row>


                    </Col>

                  </Row>
                </div >
              </Col>
            </Row>
            {/* <Footer /> */}
            {/* <Row>
              <Col lg={12} md={12} sm={12} className="">
                <Dashboardfooter />
              </Col>
            </Row> */}
          </Container>
        </div>
      </div>
      </div>

    </>
  )
}

export default Simplestaking;
